<div class="asset-meta">
  <div
    class="asset-name"
    (click)="onThumbnailBarOpen.emit(!thumbnailBarOpen)"
    [appTooltip]="'thumbnails' | translate"
    tooltipKeyboardShortcut="↑ / ↓"
  >
    <span class="asset-name-span">
      {{ asset.version_data.asset_name }}
    </span>
    <div class="asset-count" [class.center]="center" [class.active]="thumbnailBarOpen">
      <app-svg src="/assets/icons/12/arrow-down.svg"></app-svg>
    </div>
  </div>
  @if (allowVersionHistory()) {
    <app-context-menu [options]="{ width: '440px', noSpacing: true }" #menu (onToggle)="onToggle()">
      @if (asset['versions_total_count'] > 1) {
        <div class="version" contextButton appClickTrack name="version" location="asset-page-header">
          {{ asset.version_data.version_name || 'v1' | uppercase }}
          <app-svg src="/assets/icons/12/arrow-down.svg"></app-svg>
        </div>
      }
      @if (menu.isOpen) {
        <app-asset-version-menu contextContent [asset]="asset"></app-asset-version-menu>
      }
    </app-context-menu>
  }
</div>
